import React from 'react';
import { CircleFadingArrowUp } from 'lucide-react';
import { ArrowUpFromDot } from 'lucide-react';

import Footer from './footer';
import Header from './header';
import { Button } from './ui/button';

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [showButton, setShowButton] = React.useState(false);
  const topRef = React.useRef<HTMLDivElement>(null);

  const handleScrollToTop = () => {
    window?.scrollTo({ 
      top: topRef.current?.offsetTop,
      behavior: "smooth"
    });
  }

  React.useEffect(() => {
    const handleScrollButtonVisibility = () => {
      window?.pageYOffset > 1200 ? setShowButton(true): setShowButton(false);
    }
    window?.addEventListener('scroll', handleScrollButtonVisibility);

    return () => {
      window?.removeEventListener('scroll', handleScrollButtonVisibility);
    }
  },[])
  return (
    <div className='w-full h-full min-h-screen bg-[conic-gradient(at_bottom_right,_var(--tw-gradient-stops))] from-white via-gray-50 to-gray-100'>
      <div className='container' ref={topRef}>
        <Header />
        {children}
        <Footer />
      </div>
      {showButton && <Button className="fixed bottom-5 right-7 z-50 cursor-pointer rounded"
      variant="secondary"
       onClick={handleScrollToTop}>
        <ArrowUpFromDot size={18} />
        </Button>}
    </div>
  );
};
export default Layout;
